module.exports = __webpack_public_path__ + "static/img/so1_1.e91ff18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so1_1.jpg
// module id = 7XYE
// module chunks = 11